import { useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useSessionExpiration } from './useSessionExpiration';

export const useAutoLogout = () => {
  const { currentUser, authProvider } = useAuth();

  // Initialize session expiration hook for MSAL and Firebase users
  const sessionExpiration = useSessionExpiration();

  // Refresh session timestamp on user activity
  const refreshSession = useCallback(() => {
    if (currentUser && (authProvider === 'msal' || authProvider === 'firebase')) {
      const timestamp = new Date().toISOString();
      localStorage.setItem('msal_login_timestamp', timestamp);
    }
  }, [currentUser, authProvider]);

  // Set up event listeners for user activity to refresh session
  useEffect(() => {
    if (!currentUser || (authProvider !== 'msal' && authProvider !== 'firebase')) {
      return;
    }

    const events = ['mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'touchmove'];
    
    events.forEach(event => {
      document.addEventListener(event, refreshSession, { passive: true });
    });

    // Cleanup function
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, refreshSession);
      });
    };
  }, [currentUser, authProvider, refreshSession]);

  // Return session expiration data for all authenticated users
  return {
    ...sessionExpiration
  };
}; 